/**
 * Created by pajicv on 9/28/18.
 */
import React from 'react';
import { CardContent, TextField, withStyles } from '@material-ui/core';

const styles = theme => ({
    nameContent: {
        height: 40,
        marginBottom: 80
    },
    textField: {
        marginLeft: theme.spacing.unit,
        marginRight: theme.spacing.unit,
        marginTop: 20,
        width: 400
    },
    input: {
        textAlign: 'center'
    }
});

class CycleTitle extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            title: props.title
        };
    }

    handleChangeValue = (event) => {
        this.setState({ title: event.target.value });
    };

    render() {
        const { classes, onTitleBlur } = this.props;
        const { title } = this.state;
        return (
            <div style={{ alignContent: 'center' }}>
                <TextField
                    label="Titel"
                    margin="normal"
                    value={title}
                    className={classes.textField}
                    onChange={this.handleChangeValue}
                    onBlur={(event) => onTitleBlur(event.target.value)}
                    inputProps={{
                        className: classes.input
                    }}
                    placeholder="Define CX cycle title"
                />
            </div>
        );
    }
}

export default withStyles(styles)(CycleTitle);


// WEBPACK FOOTER //
// ./src/components/common/CycleTitle.js